/*
 * Copyright (c) 2008-2019 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

import moment from "moment"
import { log } from "~/common/src/utils/log"
import Vue from "vue"
import { v4 as UUIDv4 } from "uuid"

const statusTypeLookup = Object.freeze({
  CANCELLED: "warning",
  COMPLETED: "success",
  FAILED: "danger",
  STARTED: "info",
})

export default {
  namespaced: true,

  state: {
    statusMessages: [], // { type, icon, message }
  },

  mutations: {
    // todo DEV-3200: loadFromLocalStorage, addToLocalStorage

    /**
     * add status update to list of visible updates
     */
    addStatusMessage(state, data) {
      data.type = statusTypeLookup[data.status]
      data.id = UUIDv4()
      data.visible = true
      data.timestamp = moment.now()

      state.statusMessages.push(data)
    },

    hideStatusMessage(state, id) {
      const statusMessage = state.statusMessages.find((status) => status.id === id)
      if (statusMessage) {
        statusMessage.visible = false
      } else {
        log.debug("StatusMessage not found: id", id)
      }
    },

    clear(state) {
      Vue.set(state, "statusMessages", [])
      // todo DEV-3200: remove statusMessages list from localStorage
    },

    hideAllWithMainMeetingId(state, mainMeetingId) {
      if (!mainMeetingId) return
      for (const statusMessage of state.statusMessages) {
        if (statusMessage.mainMeetingId === mainMeetingId) {
          statusMessage.visible = false
        }
      }
    },
  },

  getters: {
    /**
     * Returns the list of currently visible status messages.
     */
    getVisibleStatusMessages: (state) => {
      return state.statusMessages.filter((statusMessage) => statusMessage.visible)
    },
  },
}
